import { motion } from "framer-motion";

export default function About({ siteInfo }) {
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32 bg-sand-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="md:col-span-5"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-sage font-bold mb-6" data-testid="about-overline">Über uns</p>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight mb-6" data-testid="about-headline">
              Ein Handwerk. <br /><em>Ein Versprechen.</em>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="md:col-span-7 md:pt-4"
          >
            <p className="text-lg text-stone-600 leading-relaxed mb-8" data-testid="about-description">
              {siteInfo?.description}
            </p>

            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-sand-300">
              <div data-testid="about-stat-years">
                <p className="font-display text-5xl text-clay leading-none">{siteInfo?.years_experience}</p>
                <p className="text-xs uppercase tracking-[0.2em] text-stone-600 mt-3">Jahre Erfahrung</p>
              </div>
              <div data-testid="about-stat-projects">
                <p className="font-display text-5xl text-clay leading-none">{siteInfo?.projects_completed}+</p>
                <p className="text-xs uppercase tracking-[0.2em] text-stone-600 mt-3">Abgeschlossene Projekte</p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="md:col-span-8 aspect-[16/10] overflow-hidden rounded-sm"
          >
            <img
              src="https://images.pexels.com/photos/13141770/pexels-photo-13141770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1200"
              alt="Heller, modern gestrichener Wohnraum"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="md:col-span-4 aspect-[3/4] overflow-hidden rounded-sm"
          >
            <img
              src="https://images.pexels.com/photos/12998745/pexels-photo-12998745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
              alt="Putztextur an einer Wand"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
